import React from 'react';

const STATS = [
  { number: '80%', desc: <>of closet clothes worn<br />fewer than 5 times</> },
  { number: '$0', desc: <>for designers<br />to list their work</> },
  { number: 'AI', desc: <>virtual try-on on<br />every single piece</> },
];

const SustainabilitySection = () => {
  return (
    <section className="landing-sustain-band">
      <div className="landing-sustain-quote">
        We believe fashion should be{' '}
        <span>experienced, not wasted.</span> Virtual try-on reduces returns.
        Renting extends lifecycles. Independent design challenges fast fashion.
      </div>
      <div className="landing-sustain-divider" />
      <div className="landing-sustain-stats">
        {STATS.map((stat, i) => (
          <div className="landing-sustain-stat" key={i}>
            <div className="landing-sustain-number">{stat.number}</div>
            <div className="landing-sustain-desc">{stat.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SustainabilitySection;
